import React, { useState, useEffect, useContext } from 'react';
import { UserOrderContext } from 'context/context';
import { isMobileDevice, isSupportedTenantCode } from 'common/utilities/utils';
import { RESIZE } from 'common/constants/SharedConstants';
import ProtectedDisclosureHeader from 'organisms/ProtectedDisclosure/Presentation/ProtectedDisclosureHeader';
import ProtectedDisclosureQuestions from 'organisms/ProtectedDisclosure/Presentation/ProtectedDisclosureQuestions';
import { ClearCartModule } from 'organisms/ClearCartModule/Container/ClearCartComponent';

const ProtectedDisclosureContainer = props => {
  const { content: { headerDetails = {}, questions = [] } = {}, userParams } = props;
  const [isMobileOrNot, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const { userOrderState } = useContext(UserOrderContext);
  const window_Resized = () => {
    const isMobileViewOrNot = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileViewOrNot);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    window.addEventListener(RESIZE, window_Resized);
  }, [isMobileOrNot]);
  const desktopVersionTermsOfUse = () => {
    return (
      <div className={`protected-desktop-container ${isSupportedTenantCode() && 'protected-disclosure-au'}`}>
        <div className='protected-section-left'>
          <ProtectedDisclosureHeader headerData={headerDetails} userParams={userParams} />
        </div>
        <div className='protected-section-right'>
          <div className='protected-questions-desktop'>
            <ProtectedDisclosureQuestions
              questionList={questions}
              headerData={headerDetails}
              isMobile={isMobileOrNot}
            />
          </div>
        </div>
        {userOrderState.showCartClearAlert ? <ClearCartModule /> : null}
      </div>
    );
  };
  const mobileVersionTermsOfUse = () => {
    return (
      <div className='protected-mobile-container'>
        <div className='protected-mobile-header'>
          <ProtectedDisclosureHeader headerData={headerDetails} />
        </div>
        <div className='protected-mobile-questions'>
          <ProtectedDisclosureQuestions questionList={questions} headerData={headerDetails} isMobile={isMobileOrNot} />
        </div>
        {userOrderState.showCartClearAlert ? <ClearCartModule /> : null}
      </div>
    );
  };
  return isMobileOrNot ? mobileVersionTermsOfUse() : desktopVersionTermsOfUse();
};
export default ProtectedDisclosureContainer;
